import { useFormik } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

import { AddComboSectionSchema } from '../../../validation/validate'

import { ComboItemParentRaw } from '../../../redux-toolkits/products/products.type'
import { Checkbox } from '../../inputs/Checkbox'

export const AddComboSectionModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: (val: ComboItemParentRaw) => void
  mode: 'edit' | 'create'
  comboParent?: ComboItemParentRaw
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = (val) => {},
  mode,
  comboParent,
}) => {
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
    initialValues,
  } = useFormik({
    initialValues: comboParent
      ? {
          name: comboParent.groupName,
          description: comboParent.groupDescription,
          required: comboParent.required,
          minimumQuantity: String(comboParent.minimumQuantity ?? '0'),
          maximumQuantity: String(comboParent.maximumQuantity ?? '1'),
          items: comboParent.items,
        }
      : {
          name: '',
          description: '',
          required: true,
          minimumQuantity: '0',
          maximumQuantity: '1',
          items: [],
        },
    enableReinitialize: true,
    validationSchema: AddComboSectionSchema,
    onSubmit: (values, { resetForm }) => {
      const itemToAdd: ComboItemParentRaw = {
        groupName: values.name,
        groupDescription: values.description,
        required: values.required,
        minimumQuantity: Number(values.minimumQuantity),
        maximumQuantity: Number(values.maximumQuantity),
        items: values.items,
      }

      onSuccessCallback(itemToAdd)
      resetForm()
    },
  })

  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={mode === 'create' ? 'Add Combo Section' : 'Edit Combo Section'}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-2 gap-4">
          <TextInput
            type="text"
            name="name"
            placeholder="Name"
            value={values.name}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={errors.name && touched.name ? errors.name : ''}
            hasIcon={false}
            title="Name"
            containerClassName="col-span-full"
          />

          <TextInput
            type="textarea"
            name="description"
            placeholder="Description"
            value={values.description}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={
              errors.description && touched.description
                ? errors.description
                : ''
            }
            hasIcon={false}
            title="Description"
            containerClassName="col-span-full"
          />

          <TextInput
            type="text"
            name="minimumQuantity"
            placeholder="Minimum quantity"
            value={values.minimumQuantity}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={
              errors.minimumQuantity && touched.minimumQuantity
                ? errors.minimumQuantity
                : ''
            }
            hasIcon={false}
            title="Minimum quantity"
          />

          <TextInput
            type="text"
            name="maximumQuantity"
            placeholder="Maximum quantity"
            value={values.maximumQuantity}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={
              errors.maximumQuantity && touched.maximumQuantity
                ? errors.maximumQuantity
                : ''
            }
            hasIcon={false}
            title="Maximum quantity"
          />

          <Checkbox
            text="This is a required section"
            checkStatus={values.required}
            handleChange={(status) => {
              setFieldValue('required', status)
            }}
            className="col-span-full"
          />
        </div>

        <Button
          label="Proceed"
          type="submit"
          className="mt-10"
          disabled={!isValid}
          loading={false}
          primary
          onClick={() => {
            handleSubmit()
          }}
        />
      </div>
    </ModalComponent>
  )
}
